module.exports = __webpack_public_path__ + "img/instagram.74479a1e.svg";